import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";

export const ACCOUNTS_QUERY_KEY = ["accounts"] as const;

export type ListAccountsQuery = {
  include_deleted?: boolean;
};

export function useAccounts(params: ListAccountsQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ACCOUNTS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/accounts", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list accounts");
      }
      return data;
    },
  });
}
